import { Injectable } from '@angular/core';
import { NetworkService } from '../infrastructure/network.service';
import { ConfigService } from '../infrastructure/config.service';
import { BehaviorSubject } from 'rxjs';
import { saveAs } from 'file-saver';
import { MasterConstants } from './../../common/constants/master-constants';
import { LocalStorageService } from '../infrastructure/local-storage.service';

@Injectable()
export class CommonService {
  constructor(private networkService: NetworkService, private configService: ConfigService, private localStorageService: LocalStorageService) {
    this.seedOrderTabIndex = new BehaviorSubject(0);
    this.seedOrderGrowerGMK = new BehaviorSubject(0);
    this.seedOrderDealerAccount = new BehaviorSubject(0);
  }
  currentTabIndex = new BehaviorSubject(0);
  seedOrderTabIndex: BehaviorSubject<number>;
  seedOrderGrowerGMK: BehaviorSubject<number>;
  seedOrderDealerAccount: BehaviorSubject<number>;

  public setSeedOrderTabIndex(value: number) {
    this.seedOrderTabIndex.next(value);
  }

  public setSeedOrderGrowerGMK(value: number) {
    this.seedOrderGrowerGMK.next(value);
  }

  public setSeedOrderDealerAccount(value: number) {
    this.seedOrderDealerAccount.next(value);
  }

  // To get ProductLine master data
  public getMasterData() {
    return this.networkService.getRequest(this.configService.getMasterDataUrl());
  }

  public getHybridVarietyMasterData() {
    return this.networkService.getRequest(this.configService.geHybridVarietyMasterDataUrl());
  }

  // To get ProductLine master data
  public getFilterDDLData() {
    return this.networkService.getRequest(this.configService.getFilterDataUrl());
  }

  // To get grower search master data
  public getGrowerSearchData() {
    return this.networkService.getRequest(this.configService.getGrowerSearchDataUrl());
  }

  // To get ProductLine master data
  public getGrowerSearchApi(searchFilter) {
    return this.networkService.postRequest(this.configService.getGrowerSearchApiUrl(), searchFilter);
  }

  // To get Message Configuration by Code
  public getMessageConfiguration(code) {
    return this.networkService.getRequest(this.configService.getMessageConfigurationUrl() + '?code=' + code);
  }

  // Add new Grower
  public postNewGrowerAdd(data: any) {
    return this.networkService.postRequest(this.configService.getaddNewGrowerUrl(), data);
  }

  // Add to system new Grower
  public AddToSystemGrower(data: any) {
    return this.networkService.postRequest(this.configService.NewGrowerAddToSystemUrl(), data);
  }

  // Request new grower
  public requestNewGrower(code, data: any) {
    return this.networkService.postRequest(this.configService.requestNewGrowerUrl() + '?code=' + code, data);
  }

  // Map or fetch GMK
  public mapOrFetchGmk(accountNumber: number) {
    return this.networkService.postRequest(this.configService.mapOrFetchGmkUrl(), accountNumber);
  }

  // signOut
  public signOut(userId: any, evolveAccountRestriction: any, companyCode: string, emulationUserId: string) {
    return this.networkService.getRequest(this.configService.signOutUrl() + '?userId=' + userId + '&evolveAccountRestriction=' + evolveAccountRestriction + '&companyCode=' + companyCode + '&emulationUserId=' + emulationUserId);
  }

  // To get filter data for quick report
  public getReportFilterDDLValues(cropYear) {
    return this.networkService.getRequest(this.configService.getReportFilterUrl() + '?cropYear=' + cropYear);
  }

  // to get company details
  public getCompanyDetails() {
    return this.networkService.getRequest(this.configService.getCompanyNameUrl());
  }

  // Get ItemNumbers
  public getItemNumbers() {
    return this.networkService.getRequest(this.configService.getItemNumberMasterUrl());
  }

  // To get CPP Filter data
  public getCPPFilterData(accountNo: number) {
    return this.networkService.getRequest(this.configService.getCPPFilterDataUrl() + '?accountNo=' + accountNo);
  }

  public getFormatedNumber(num, isAddCommas: boolean = true) {
    let retVal = '0';

    if (num) {
      retVal = parseFloat(num).toFixed(MasterConstants.NUMBER_SCALE).replace(/(\.0+|0+)$/, '');
    }

    // if (isAddCommas && retVal) {
    //  retVal = this.numberWithCommas(retVal);
    // }

    return retVal;
    // return num;
  }
  public getFormatedNumberWithColour(num, isAddCommas: boolean = true) {
    let retVal = '0';
    let color = 'black'; // Default color

    if (num) {
      retVal = parseFloat(num).toFixed(MasterConstants.NUMBER_SCALE).replace(/(\.0+|0+)$/, '');
    }

    if (num < 0) {
      retVal = `(${retVal.replace('-', '')})`; // Remove negative sign and wrap in parentheses
      color = 'red'; // Set color to red for negative numbers
    }

    return { value: retVal, color: color };
  }
  private numberWithCommas(x) {
    // return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    return x;
  }

  public countDecimals(value) {
    if (Math.floor(value) !== value) {
      let len = value.toString().split('.')[1].length || 0;
      len = len > 4 ? 4 : len;
      return len;
    }
    return 0;
  }

  public GetTimeForFileName() {
    const currentDateTime = new Date();
    return currentDateTime.getDate() + '_' + (currentDateTime.getMonth() + 1) + '_' + currentDateTime.getFullYear() + '_' + currentDateTime.getHours() + '' + currentDateTime.getMinutes() + '' + currentDateTime.getSeconds();
  }

  // Check COI Access
  public checkCoiAccess() {
    return this.networkService.getRequest(this.configService.checkCoiAccess);
  }

  public isEmailAddressValid(emailAddress: string): boolean {
    let retVal = true;
    let emailList = [];

    if (emailAddress) {
      emailAddress = emailAddress.replace(/  +/g, ' ');
      emailList = emailAddress.split(';');
    }

    emailList.forEach(email => {
      if (!MasterConstants.EMAIL_PATTERN.test(email)) {
        retVal = false;
      }
    });

    return retVal;
  }

  public isNumber(n) {
    return !isNaN(parseFloat(n)) && !isNaN(n - 0);
  }

  public keyPressNumbers(event) {
    var numbers = /^[-+]?[0-9]+$/;
    if (!numbers.test(event.key)) {
      return false;
    }
  }

  public base64toFile(base64String, contentType, fileName) {
    var blob = this.b64toBlob(base64String, contentType, 550);
    saveAs(blob, fileName);
  }

  //Convert b64 to BLOB
  public b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    b64Data = b64Data.replace(/\s/g, ''); //IE compatibility...
    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  public validateEmail(emailAddress: string, isMultipleEmailAllowed: boolean = false) {
    let emailList = [];
    let status = false;
    let count = 0;
    if (emailAddress) {
      if (isMultipleEmailAllowed) {
        emailAddress = emailAddress.replace(/  +/g, ' ');
        emailList = emailAddress.split(';');
        emailList.forEach(email => {
          if (email != '') {
            if (!MasterConstants.EMAIL_PATTERN.test(email) || !MasterConstants.INDIVIDUAL_EMAIL_PATTERN.test(email)) {
              count = count + 1;
            } else if (email.indexOf(' ') >= 0) {
              count = count + 1;
            }
          }
        });
      }
      else {
        if (!MasterConstants.INDIVIDUAL_EMAIL_PATTERN.test(emailAddress)) {
          count = count + 1;
        } else if (emailAddress.indexOf(' ') >= 0) {
          count = count + 1;
        }
      }
    }
    if (count > 0) {
      status = true;
    }
    else {
      status = false;
    }

    return status;
  }

  checkUserRoleAccessTypeForMenu(userMenuAccessList: any, functionCode: string): boolean {
    let retVal = false;

    if (!userMenuAccessList) {
      userMenuAccessList = this.getUserMenuAccessList();
    }

    if (userMenuAccessList && userMenuAccessList.length > 0) {
      if (userMenuAccessList.find(x => x.functionCode.trim() == functionCode)
        && userMenuAccessList.find(x => x.functionCode.trim() == functionCode).accessType.trim().toUpperCase() != MasterConstants.USER_ACCESS.BLANK) {
        retVal = true;
      }
    }

    return retVal;
  }

  checkUserRoleAccessType(functionCode: string, accessType: string = MasterConstants.USER_ACCESS.READ_ONLY, userMenuAccessList: any = null): boolean {
    let retVal = false;

    if (!userMenuAccessList) {
      userMenuAccessList = this.getUserMenuAccessList();
    }

    if (userMenuAccessList && userMenuAccessList.length > 0) {
      if (userMenuAccessList.find(x => x.functionCode.trim() == functionCode)
        && userMenuAccessList.find(x => x.functionCode.trim() == functionCode).accessType.trim().toUpperCase() === accessType) {
        retVal = true;
      }
    }

    return retVal;
  }

  public getAutoSaveConfigurations(processName) {
    return this.networkService.getRequest(this.configService.getAutoSaveConfigUrl + '?processName=' + processName);
  }

  private getUserMenuAccessList() {
    let retVal;
    let headerCompany: any;

    if (this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE)) {
      headerCompany = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE));
    }

    var evolveAccessData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
    if (evolveAccessData) {
      retVal = evolveAccessData.resultData.find(x => x.userIdCompanyCode == headerCompany).userMenuAccessList;
    }

    return retVal;
  }

  public setDataLayerAnalytics(events) {
    window['storeDataLayerAnalytics'](events);
  }


  public getSeasonBannerUrl(fromPage: string) {
    return this.networkService.getRequest(this.configService.getSeasonBannerUrl() + '?fromPage=' + fromPage);
  }

  // AI Service

  public getAICPPProductSearch(message) {
    return this.networkService.postRequest(this.configService.getaiCPPProductSearchUrl(), message);
  }

  public getAIResponse(message) {
    return this.networkService.postRequest(this.configService.getAiResponseUrl(), message);
  }

  public getUserSelectedAccountForChat() {
    return this.networkService.getRequest(this.configService.getUserSlectedAccountForChatUrl());
  }

  public resetAISession() {
    return this.networkService.getRequest(this.configService.getairesetUrl());
  }

  public getAIChatMenuConfig() {
    return this.networkService.getRequest(this.configService.getaimenuconfigUrl());
  }
  public reviewAIOrder(payload) {
    return this.networkService.postRequest(this.configService.getaiReviewCppOrderUrl(), payload);
  }
  public placeAICPPOrder(payload) {
    return this.networkService.postRequest(this.configService.getaiPlaceCppOrderUrl(), payload);
  }
  public sendEmail() {
    return this.networkService.getRequest(this.configService.gettrackingemailUrl());
  }
  public createConversation() {
    return this.networkService.getRequest(this.configService.getSFChatUrl());
  }
  public sendSFMessage(message) {
    return this.networkService.postRequest(this.configService.getsfmessageUrl(), message);
  }
  public recentConversation(convId) {
    return this.networkService.getRequest(this.configService.getrecentChatUrl() + '?convId=' + convId);
  }
  public closeConversation(convId) {
    return this.networkService.getRequest(this.configService.getcloseConversationUrl() + '?convId=' + convId);
  }
  public sendSFTranscript(convId) {
    return this.networkService.getRequest(this.configService.getsfTranscriptUrl() + '?convId=' + convId);
  }
}
